var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnonymousDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2439_18457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2045 63.2785H12.8423C11.6894 63.2785 10.7549 62.344 10.7549 61.1911V59.6846C10.7549 58.5317 11.6894 57.5965 12.8423 57.5965H17.2045V63.2785Z",
    fill: "url(#paint0_linear_2439_18457)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7949 63.2785H77.1572C78.3101 63.2785 79.2446 62.344 79.2446 61.1911V59.6846C79.2446 58.5317 78.3101 57.5965 77.1572 57.5965H72.7949V63.2785Z",
    fill: "url(#paint1_linear_2439_18457)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7551 60.7318L47.2811 60.7434L37.2451 60.7647V66.1961H43.1255C43.2498 65.6447 43.3233 65.094 43.348 64.5474C43.3885 63.6651 44.1164 62.9716 45.0001 62.9716C45.8838 62.9716 46.6116 63.6651 46.6522 64.5474C46.6769 65.094 46.7504 65.6447 46.8746 66.1961H52.7551V60.7318Z",
    fill: "url(#paint2_linear_2439_18457)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7441 56.3681H52.2557V58.5949H37.7441V56.3681Z",
    fill: "url(#paint3_linear_2439_18457)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9517 78.1746H27.0367C19.2892 78.1746 13.0078 71.8938 13.0078 64.1457C13.0078 58.9176 17.2465 54.679 22.4746 54.679H33.8846C40.6233 54.679 45.2039 61.5193 42.6386 67.7499L41.9231 69.4872C39.7588 74.7434 34.6358 78.1746 28.9517 78.1746Z",
    fill: "url(#paint4_linear_2439_18457)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8159 76.1009H27.2393C20.859 76.1009 15.6865 70.9284 15.6865 64.5481C15.6865 60.2422 19.1767 56.752 23.4827 56.752H32.8788C38.4282 56.752 42.2007 62.3852 40.0878 67.5165L39.4987 68.9468C37.7162 73.2761 33.4974 76.1009 28.8159 76.1009Z",
    fill: "url(#paint5_linear_2439_18457)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0482 78.1746H62.9633C70.7107 78.1746 76.9921 71.8938 76.9921 64.1457C76.9921 58.9176 72.7535 54.679 67.5253 54.679H56.1154C49.3766 54.679 44.796 61.5193 47.3613 67.7499L48.0768 69.4872C50.2411 74.7434 55.3642 78.1746 61.0482 78.1746Z",
    fill: "url(#paint6_linear_2439_18457)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1846 76.1009H62.7611C69.1414 76.1009 74.3139 70.9284 74.3139 64.5481C74.3139 60.2422 70.8237 56.752 66.5177 56.752H57.1217C51.5722 56.752 47.7998 62.3852 49.9126 67.5165L50.5017 68.9468C52.2843 73.2761 56.503 76.1009 61.1846 76.1009Z",
    fill: "url(#paint7_linear_2439_18457)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6382 67.7499L41.9234 69.4865C41.1489 71.3679 39.9967 73.0145 38.574 74.3555L19.4111 55.1905L19.4062 55.1871C20.3676 54.8568 21.4003 54.679 22.4749 54.679H33.8835C40.6229 54.679 45.2042 61.5186 42.6382 67.7499Z",
    fill: "url(#paint8_linear_2439_18457)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 46.5429C90 40.7283 69.8531 36.0145 45 36.0145C20.1469 36.0145 0 40.7283 0 46.5429C0 52.3581 20.1469 57.0719 45 57.0719C69.8531 57.0719 90 52.3581 90 46.5429Z",
    fill: "url(#paint9_linear_2439_18457)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 55.4247C21.332 55.4247 1.93222 51.1496 0.135956 45.7196C0.0466919 45.9915 0 46.2662 0 46.5429C0 52.3581 20.1469 57.0719 45 57.0719C69.8531 57.0719 90 52.3581 90 46.5429C90 46.2662 89.9533 45.9915 89.864 45.7196C88.0678 51.1496 68.668 55.4247 45 55.4247Z",
    fill: "url(#paint10_linear_2439_18457)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9997 46.5429C89.9997 40.7283 69.8528 36.0145 44.9997 36.0145C33.4235 36.0145 22.8691 37.0376 14.8951 38.7178C14.1624 40.5484 13.7168 41.6945 13.7168 41.7782C13.7168 42.4594 14.1164 43.1192 14.8601 43.7448L27.346 56.2307C32.7664 56.7718 38.7334 57.0719 44.9997 57.0719C69.8528 57.0719 89.9997 52.3581 89.9997 46.5429Z",
    fill: "url(#paint11_linear_2439_18457)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0721 13.7989C47.8575 16.8723 42.1419 16.8723 37.9272 13.7989C32.9003 10.1335 25.7688 12.1461 23.4006 17.8995C19.2134 28.0735 13.7168 41.4837 13.7168 41.779C13.7168 45.8213 27.723 49.0979 44.9997 49.0979C62.2771 49.0979 76.2826 45.8213 76.2826 41.779C76.2826 41.4837 70.7867 28.0735 66.5988 17.8995C64.2312 12.1461 57.0991 10.1335 52.0721 13.7989Z",
    fill: "url(#paint12_linear_2439_18457)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9997 40.7449C31.8175 40.7449 20.5407 38.8374 15.9353 36.1368C14.6033 39.4265 13.7168 41.6602 13.7168 41.7783C13.7168 45.8212 27.723 49.0979 44.9997 49.0979C62.2764 49.0979 76.2826 45.8205 76.2826 41.7783C76.2826 41.6602 75.3961 39.4265 74.064 36.1368C69.4587 38.8374 58.1819 40.7449 44.9997 40.7449Z",
    fill: "url(#paint13_linear_2439_18457)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6472 14.1065C59.6472 13.4274 59.5758 12.762 59.4453 12.1138C56.9754 11.662 54.3147 12.1646 52.0728 13.7995C47.8582 16.8723 42.1425 16.8723 37.9279 13.7995C35.686 12.1646 33.0253 11.662 30.5554 12.1138C30.4249 12.762 30.3535 13.4274 30.3535 14.1065C30.3535 20.7738 36.911 26.1791 45.0004 26.1791C53.0897 26.1791 59.6472 20.7738 59.6472 14.1065Z",
    fill: "url(#paint14_radial_2439_18457)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2439_18457",
    x1: 13.98,
    y1: 57.9299,
    x2: 13.98,
    y2: 59.3321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B395F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2439_18457",
    x1: 76.0195,
    y1: 57.9299,
    x2: 76.0195,
    y2: 59.3321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B395F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2439_18457",
    x1: 45.0001,
    y1: 61.0519,
    x2: 45.0001,
    y2: 62.4005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B395F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2439_18457",
    x1: 44.9999,
    y1: 56.1378,
    x2: 44.9999,
    y2: 57.7521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B395F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2439_18457",
    x1: 25.5047,
    y1: 54.2196,
    x2: 30.5724,
    y2: 73.5687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B395F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2439_18457",
    x1: 27.2987,
    y1: 62.8373,
    x2: 35.3608,
    y2: 81.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B53759",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB5B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2439_18457",
    x1: 64.4952,
    y1: 54.2196,
    x2: 59.4276,
    y2: 73.5687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B395F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2439_18457",
    x1: 59.9086,
    y1: 61.1463,
    x2: 70.9652,
    y2: 81.8775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B53759",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB5B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2439_18457",
    x1: 35.4629,
    y1: 75.4064,
    x2: 31.0512,
    y2: 57.7593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4A72",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B395F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2439_18457",
    x1: 43.2225,
    y1: 34.9896,
    x2: 47.8108,
    y2: 64.8131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2137,
    stopColor: "#FEC33A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4325,
    stopColor: "#FBB740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6535,
    stopColor: "#F5A24B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8748,
    stopColor: "#EE865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2439_18457",
    x1: 45.3776,
    y1: 38.5198,
    x2: 44.4364,
    y2: 58.5198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2137,
    stopColor: "#FEC33A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4325,
    stopColor: "#FBB740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6535,
    stopColor: "#F5A24B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8748,
    stopColor: "#EE865A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2439_18457",
    x1: 56.4378,
    y1: 60.8869,
    x2: 42.4378,
    y2: 9.59274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B53759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2439_18457",
    x1: 36.882,
    y1: 30.5255,
    x2: 60.3234,
    y2: 30.5255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2439_18457",
    x1: 40.6589,
    y1: 31.4511,
    x2: 50.5584,
    y2: 55.0051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E7B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#02E3B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#08D7AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#12C2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6406,
    stopColor: "#21A698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8029,
    stopColor: "#338189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#495577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4A72"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2439_18457",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.7651 14.4786) scale(12.6556 7.66675)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B53759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3639,
    stopColor: "#CD525E",
    stopOpacity: 0.635294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7545,
    stopColor: "#E26962",
    stopOpacity: 0.247059
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97264",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2439_18457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnonymousDashboard);
export default __webpack_public_path__ + "static/media/anonymousDashboard.bb1e014d9ec3b7adceb328f4f7d3377e.svg";
export { ForwardRef as ReactComponent };